import type { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import { forwardRef, useImperativeHandle, useRef } from 'react';

const Checkbox = forwardRef<
  HTMLInputElement,
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
    error?: unknown;
  }
>(({ error: _error, ...props }, ref): JSX.Element => {
  const checkboxRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => checkboxRef.current as HTMLInputElement);

  return (
    <div className="flex h-6 items-center">
      <input
        {...props}
        id={props.id || props.name}
        name={props.name}
        type="checkbox"
        className="size-6 rounded-sm border-0 text-emerald-500 shadow-xs ring-1 ring-zinc-300 focus:ring-2 focus:ring-emerald-500 dark:bg-white/5 dark:text-emerald-400 dark:ring-white/10 dark:focus:ring-emerald-400 dark:focus:ring-offset-zinc-800"
        ref={checkboxRef}
      />
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
